var map = {
	"./en/bio.ts": [
		5386,
		5386
	],
	"./en/common.ts": [
		33661,
		3661
	],
	"./en/my.ts": [
		81726,
		1726
	],
	"./en/priority.ts": [
		5348,
		5348
	],
	"./es/bio.ts": [
		165,
		165
	],
	"./es/common.ts": [
		54400,
		4400
	],
	"./es/my.ts": [
		79319,
		9319
	],
	"./es/priority.ts": [
		55997,
		5997
	],
	"./index.ts": [
		99133
	],
	"./ko/bio.ts": [
		90503,
		503
	],
	"./ko/common.ts": [
		19094,
		9094
	],
	"./ko/my.ts": [
		68893,
		8893
	],
	"./ko/priority.ts": [
		47007,
		7007
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89639;
module.exports = webpackAsyncContext;